import {
  Box,
  Drawer,
  Skeleton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Logo from "../../../assets/images/Logo/Logo.png";
import Dashboard from "../../../assets/images/Icons/ic_dashboard_layout.svg";
import User from "../../../assets/images/Icons/ic_user.svg";
import Catalog from "../../../assets/images/Icons/ic_category.svg";
import Stores from "../../../assets/images/Icons/ic_store.svg";
import Customers from "../../../assets/images/Icons/ic_customer.svg";
import ClientAccount from "../../../assets/images/Icons/ic_client_account.svg";
import Sales from "../../../assets/images/Icons/ic_order.svg";
import Promotions from "../../../assets/images/Icons/ic_discount.svg";
import Loyalty from "../../../assets/images/Icons/ic_vip_rewards.svg";
import Integrations from "../../../assets/images/Icons/ic_integration.svg";
import EndOfDay from "../../../assets/images/Icons/ic_calender.svg";
import Help from "../../../assets/images/Icons/ic_help.svg";
import EmailLog from "../../../assets/images/Icons/icon_email_log.svg";
import Reports from "../../../assets/images/Icons/ic_report.svg";
import ReportsV2 from "../../../assets/images/Icons/ic_report_v2.svg";
import QRCode from "../../../assets/images/Icons/ic_qr_code.svg";
import Accounts from "../../../assets/images/Icons/ic_cashbook.svg";
import PushNotification from "../../../assets/images/Icons/ic_push_notification.svg";
import Cms from "../../../assets/images/Icons/cms.svg";
import NotificationsAndPromo from "../../../assets/images/Icons/ic_promo_and_notification.svg";
import IcSegmentation from "../../../assets/images/Icons/ic_segmentation.svg";
import IcReview from "../../../assets/images/Icons/ic_review.svg";
import IcConfig from "../../../assets/images/Icons/ic_config.svg";
import FullTaxInvoice from "../../../assets/images/Icons/ic_fti.svg";
import TaxReports from "../../../assets/images/Icons/ic_tax_report.svg";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import version from "../../../../package.json";
import React, { useEffect } from "react";
import { SidebarMenu } from ".";
import { CMS_URL, getReportsSsoUrl, getToken } from "../../../utils";
import { useImmer } from "use-immer";
import { AppContext } from "../../../store";
import { AuthContext } from "../../../store/AuthProvider";

export const DashboardSidebar = (props) => {
  const { appState } = React.useContext(AppContext);
  const { auth } = React.useContext(AuthContext);
  const tenantName = appState?.appSettings?.name;
  // Reports v2 is an external site; the link hands the session over directly.
  const reportsV2Href = getReportsSsoUrl(
    auth?.data?.token,
    auth?.data?.tenant_id,
  );
  const [state, updateState] = useImmer({
    token: getToken(),
  });
  const token = getToken();
  const { open, onClose } = props;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
    defaultMatches: true,
    noSsr: false,
  });

  useEffect(() => {
    if (!lgUp && open) onClose?.();
  }, [lgUp]);

  useEffect(() => {
    const handleTokenChange = () => {
      updateState((draft) => {
        draft.token = getToken();
      });
    };

    window.addEventListener("token-changed", handleTokenChange);
    return () => window.removeEventListener("token-changed", handleTokenChange);
  }, [updateState]);

  const items = [
    {
      href: "/",
      icon: <img alt="icon-Dashboard" alignment="center" src={Dashboard} />,
      title: "Dashboard",
      permission: "dashboard-view",
      storeAdmin: true,
    },
    {
      icon: <img alt="icon-Catalog" alignment="center" src={Catalog} />,
      title: "Catalogue",
      storeAdmin: true,
      subMenu: [
        {
          href: "/category",
          title: "Category",
          permission: "category-view",
          storeAdmin: false,
        },
        {
          href: "/products",
          title: "Products",
          storeAdmin: true,
          permission: "product-view",
        },
        {
          href: "/availabilityGroup",
          title: "Availability Group",
          permission: "availability-group-view",
          storeAdmin: false,
        },
        {
          href: "/optionalGroup",
          title: "Modifier Groups",
          permission: "optional-group-view",
          storeAdmin: false,
        },
        {
          href: "/bundle",
          title: "Bundle Groups",
          permission: "bundle-group-view",
          storeAdmin: false,
        },
      ],
    },
    {
      icon: <img alt="icon-Sales" alignment="center" src={Sales} />,
      title: "Sales",
      storeAdmin: true,
      subMenu: [
        {
          href: "/orders",
          title: "Sales Log",
          permission: "order-view",
          storeAdmin: true,
        },
        {
          href: "/refund",
          title: "Refunds",
          permission: "refund-view",
          storeAdmin: true,
        },
        {
          href: "/payment-media-report",
          title: "Payment Media Report",
          permission: "payment-media-view",
          storeAdmin: true,
        },
        {
          href: "/wastage",
          title: "Wastage",
          permission: "wastage-view",
          storeAdmin: true,
        },
        {
          href: "/discount-orders",
          title: "Discount Sales Log",
          permission: "order-view",
          storeAdmin: true,
        },
      ],
    },
    {
      icon: <img alt="icon-Promotions" alignment="center" src={Promotions} />,
      title: "Promotions",
      subMenu: [
        {
          href: "/coupons",
          title: "Coupons",
          permission: "coupon-view",
          storeAdmin: false,
        },
        {
          href: "/coupon-report",
          title: "Coupon Report",
          permission: "coupon-view",
          storeAdmin: false,
        },
        {
          href: "/discount",
          title: "Discount",
          permission: "discount-view",
          storeAdmin: false,
        },
        {
          href: "/coupon-rules",
          title: "Coupon Rules",
          permission: "condition-view",
          storeAdmin: false,
        },
        {
          href: "/gift-card",
          title: "Gift Card",
          permission: "gift-cards-view",
          storeAdmin: false,
        },
        {
          href: "/birthday-coupons-v2",
          title: "Birthday Coupons",
          permission: "coupon-view",
          storeAdmin: false,
        },
        {
          href: "/top-selling",
          title: "Top Selling",
          permission: "product-view",
          storeAdmin: false,
        },
        {
          href: "/cart-product",
          title: "Cart Product",
          permission: "product-view",
          storeAdmin: false,
        },
        // {
        //   href: "/stamp-cards",
        //   title: "Stamp Cards",
        //   permission: "stamp-card-view",
        //   storeAdmin: false,
        // },
        // {
        //   href: "/point-promotions",
        //   title: "Point Promotions",
        //   permission: "points-promotion-view",
        //   storeAdmin: false,
        // },
      ],
    },
    {
      icon: <img alt="icon-Stores" alignment="center" src={Stores} />,
      title: "Stores",
      subMenu: [
        {
          href: "/stores",
          title: "Stores",
          permission: "store-view",
          storeAdmin: false,
        },
        {
          href: "/franchisee",
          title: "Franchisee",
          permission: "franchisee-view",
          storeAdmin: false,
        },
        {
          href: "/accounts",
          title: "Bank Accounts",
          permission: "store-view",
          storeAdmin: true,
          superAdmin: false,
        },
        {
          href: "/terminal",
          title: "Terminals",
          permission: "terminal-view",
          storeAdmin: false,
        },
      ],
    },
    {
      href: "/end-of-day",
      icon: <img alt="icon-eod" alignment="center" src={EndOfDay} />,
      title: "End of Day",
      permission: "end-of-day-view",
      storeAdmin: true,
    },
    {
      href: "/customers",
      icon: <img alt="icon-Customer" alignment="center" src={Customers} />,
      title: "Customers",
      permission: "customer-view",
      storeAdmin: false,
    },
    {
      icon: (
        <img alt="client-account-icon" alignment="center" src={ClientAccount} />
      ),
      title: "Client Account",
      subMenu: [
        {
          href: "/client-account-v2",
          title: "Client Account",
          permission: "client-account-view",
          storeAdmin: true,
          superAdmin: true,
        },
        {
          href: "/aged-debtors-report",
          title: "Aged Debtors Report",
          permission: "client-account-aged-debtors-view",
          storeAdmin: true,
          superAdmin: true,
        },
      ],
    },
    {
      icon: <img alt="icon-User" alignment="center" src={User} />,
      title: "Users",
      subMenu: [
        {
          href: "/admin-users",
          title: "Manage Users",
          permission: "user-view",
          storeAdmin: true,
        },
        {
          href: "/roles-and-permissions",
          title: "Roles & Permissions",
          permission: "role-view",
          storeAdmin: true,
        },
      ],
    },
    {
      icon: <img alt="icon-reports" alignment="center" src={Reports} />,
      href: "/reports",
      title: "Reports",
      permission: "report-view",
      storeAdmin: true,
    },
    {
      icon: <img alt="icon-reports-v2" alignment="center" src={ReportsV2} />,
      href: reportsV2Href,
      title: "Reports v2",
      permission: "report-view",
      storeAdmin: true,
      openInNewTab: true,
    },
    {
      icon: (
        <img
          alt="icon-FullTaxInvoice"
          alignment="center"
          src={FullTaxInvoice}
        />
      ),
      href: "/full-tax-invoice",
      title: "Full Tax Invoice",
      permission: "fti-view",
      storeAdmin: true,
      feature: "fti",
    },
    {
      icon: <img alt="icon-TaxReports" alignment="center" src={TaxReports} />,
      href: "/sales-vat-report",
      title: "Tax Reports",
      permission: "fti-view",
      storeAdmin: true,
      feature: "fti",
    },
    // {
    //   icon: <InsightsOutlinedIcon sx={{ fontSize: 20, color: "#FFFCEB" }} />,
    //   title: "External Reports",
    //   storeAdmin: true,
    //   subMenu: [
    //     {
    //       href: "/store-reports",
    //       title: "Store Reports",
    //       permission: "report-view",
    //       storeAdmin: true,
    //     },
    //     {
    //       href: "/product-sales-wastage-report",
    //       title: "Product Sales & Wastage Report",
    //       permission: "report-view",
    //       storeAdmin: true,
    //     },
    //   ],
    // },
    {
      icon: (
        <img
          alt="icon-PushNotification"
          alignment="center"
          src={PushNotification}
        />
      ),
      href: "/push-notification",
      title: "Push Notification",
      permission: "push-notification-view",
      storeAdmin: false,
    },
    {
      icon: <img alt="icon-QRCode" alignment="center" src={QRCode} />,
      href: "/qr-code",
      title: "QR Code",
      permission: "qrcode-view",
      storeAdmin: false,
    },
    {
      icon: <img alt="icon-Loyalty" alignment="center" src={Loyalty} />,
      href: "/loyalty-cards",
      title: "Loyalty Cards",
      permission: "loyalty-cards-view",
      storeAdmin: false,
    },
    {
      icon: (
        <img alt="icon-Integrations" alignment="center" src={Integrations} />
      ),
      title: "Integrations",
      subMenu: [
        // {
        //   href: "/menulog",
        //   title: "Menulog",
        //   permission: "menulog-view",
        //   storeAdmin: true,
        // },
        {
          href: "/online-ordering",
          title: "Online Ordering",
          permission: "online-ordering-view",
          storeAdmin: true,
        },
        {
          href: "/ubereats",
          title: "UberEats",
          permission: "ubereats-view",
          storeAdmin: true,
        },
        // {
        //   href: "/doordash",
        //   title: "Doordash",
        //   permission: "doordash-view",
        //   storeAdmin: true,
        // },
        {
          href: "/tanda",
          title: "Tanda",
          permission: "tanda-view",
          storeAdmin: true,
        },
        {
          href: "/xero",
          title: "XERO",
          permission: "xero-myob-report-view",
          storeAdmin: true,
        },
        // {
        //   href: "/myob",
        //   title: "MYOB",
        //   permission: "xero-myob-report-view",
        //   storeAdmin: true,
        // },
        // {
        //   href: "/stripe-connect",
        //   title: "Stripe Connect",
        //   permission: "integration-view",
        //   storeAdmin: true,
        // },
      ],
    },
    {
      icon: <img alt="icon-Config" alignment="center" src={IcConfig} />,
      title: "Configurations",
      storeAdmin: true,
      subMenu: [
        {
          href: "/state-and-suburb",
          title: "State & Suburb",
          permission: "state-view",
          permission2: "city-view",
          storeAdmin: false,
        },
        {
          href: "/tax-groups-and-taxes",
          title: "Taxes",
          permission: "tax-view",
          storeAdmin: false,
        },
        // {
        //   href: "/favourites",
        //   title: "Favourites",
        //   permission: "favourite-view",
        //   storeAdmin: true,
        // },
        {
          href: "/surcharges",
          title: "Surcharges",
          permission: "surcharge-view",
          storeAdmin: false,
        },
        {
          href: "/price-levels",
          title: "Price Levels",
          permission: "price-level-view",
          storeAdmin: false,
        },
        {
          href: "/future-price",
          title: "Future Price",
          permission: "future-price-view",
          storeAdmin: false,
        },

        // {
        //   href: "/manager-password",
        //   title: "Manager Password",
        //   permission: "manager-password-view",
        //   storeAdmin: false,
        // },
        {
          href: "/bump-screen",
          title: "Bump Screens",
          permission: "bump-screen-view",
          storeAdmin: true,
          superAdmin: false,
        },
        {
          href: "/settings",
          title: "Settings",
          permission: "settings-view",
          storeAdmin: false,
        },
        {
          href: "/settings",
          title: "Store Settings",
          permission: "settings-view",
          storeAdmin: true,
          superAdmin: false,
        },
        {
          href: "/menu-banner",
          title: "Menu Banners",
          permission: "banner-view",
          storeAdmin: false,
        },
        // {
        //   href: "/menu-template",
        //   title: "Menu Template",
        //   permission: "menu-view",
        //   storeAdmin: false,
        // },
        {
          href: "/pos-settings",
          title: "POS Settings",
          permission: "pos-setting-view",
          storeAdmin: false,
        },
        {
          href: "/cfd",
          title: "CFD",
          permission: "cfd-view",
          storeAdmin: false,
        },
        // {
        //   href: "/email-settings",
        //   title: "Email Settings",
        //   permission: "email-setting-view",
        //   storeAdmin: false,
        // },
        {
          href: "/keypad",
          title: "Keypad",
          permission: "keypad-view",
          storeAdmin: false,
        },
        {
          href: "/report-settings",
          title: "Report Settings",
          permission: "report-view",
          storeAdmin: false,
        },
      ],
    },
    {
      icon: <img alt="icon-account" alignment="center" src={Accounts} />,
      title: "Accounts",
      subMenu: [
        {
          href: "/pl-dashboard",
          title: "PL Dashboard",
          permission: "pl-bs-account-view",
          storeAdmin: true,
        },
        {
          href: "/list",
          title: "PL & BS Upload",
          permission: "pl-bs-account-view",
          storeAdmin: true,
        },
        {
          href: "/pl-report",
          title: "PL & BS Report",
          permission: "pl-bs-account-view",
          storeAdmin: true,
        },

        {
          href: "/coa",
          title: "Chart Of Accounts",
          permission: "coa-view",
          storeAdmin: false,
        },
        {
          href: "/configurations",
          title: "Configurations",
          permission: "coa-view",
          storeAdmin: false,
        },
      ],
    },

    // {
    //   icon: <img alt="icon-cms" alignment="center" src={Cms} />,
    //   title: "CMS",
    //   href: `${CMS_URL}?token=${state.token}`,
    //   permission: "cms-view",
    //   storeAdmin: false,
    //   openInNewTab: true,
    // },
    // {
    //   icon: <img alt="icon-review" alignment="center" src={IcReview} />,
    //   title: "Reviews",
    //   subMenu: [
    //     {
    //       href: "/reviews-and-ratings",
    //       title: "Reviews & Ratings",
    //       permission: "review-rating-view",
    //       storeAdmin: false,
    //     },
    //     {
    //       href: "/products-ratings",
    //       title: "Product Ratings",
    //       permission: "review-rating-view",
    //       storeAdmin: false,
    //     },
    //     {
    //       href: "/configurations-review",
    //       title: "Configurations",
    //       permission: "review-rating-view",
    //       storeAdmin: false,
    //     },
    //   ],
    // },
    {
      icon: <img alt="icon-email-log" alignment="center" src={EmailLog} />,
      href: "/email-log",
      title: "Email Log",
      permission: "email-log-view",
      storeAdmin: false,
    },
    {
      icon: (
        <img
          alt="icon-email-log"
          alignment="center"
          src={NotificationsAndPromo}
        />
      ),
      href: "/promos-and-notifications",
      title: "Promos & Notifications",
      permission: "promo-notification-view",
      storeAdmin: false,
    },
    // {
    //   href: "/customer-segmentation",
    //   icon: (
    //     <img
    //       alt="icon-Customer-Segments"
    //       alignment="center"
    //       src={IcSegmentation}
    //     />
    //   ),
    //   title: "Customer Segments",
    //   permission: "segment-view",
    //   storeAdmin: false,
    // },
    {
      icon: <SettingsOutlinedIcon sx={{ fontSize: 20, color: "#4B5563" }} />,
      href: "/app-settings",
      title: "App Settings",
      permission: "settings-view",
      storeAdmin: false,
    },
    {
      icon: <SettingsOutlinedIcon sx={{ fontSize: 20, color: "#4B5563" }} />,
      href: "/tenant-config",
      title: "Tenant Config",
      permission: "settings-view",
      storeAdmin: false,
    },
    {
      icon: <img alt="icon-User" alignment="center" src={Help} />,
      href: "https://bfitpos-help.azurewebsites.net/",
      title: "Help",
      permission: "user-view",
      storeAdmin: true,
      openInNewTab: true,
    },
  ];

  // Items tagged with a tenant feature are only listed while that feature is active
  const isFeatureActive = (item) =>
    !item.feature || appState?.features?.[item.feature]?.active;

  const visibleItems = items
    .filter(isFeatureActive)
    .map((item) =>
      item.subMenu
        ? { ...item, subMenu: item.subMenu.filter(isFeatureActive) }
        : item,
    );

  const content = (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            px: 3,
            py: "20px",
          }}
        >
          {appState?.isAppSettingsFetched ? (
            <Typography
              variant="h6"
              noWrap
              title={tenantName}
              sx={{
                fontWeight: 600,
                fontSize: "18px",
                color: "#111827",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {tenantName}
            </Typography>
          ) : (
            <Skeleton variant="rounded" sx={{ width: 140, height: 24 }} />
          )}
        </Box>

        <Box sx={{ px: 2 }}>
          {visibleItems.map((item, index) => {
            return <SidebarMenu key={item.title} item={item} index={index} />;
          })}
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "30px" }}
        >
          Version {version.version}
        </Box>
      </Box>
    </>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open={open}
        className="sidebar-drawer"
        PaperProps={{
          sx: {
            backgroundColor: "#FFFFFF",
            color: "#111827",
            borderRight: "1px solid #E2E8F0",
            width: 280,
          },
        }}
        variant="persistent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      className="sidebar-drawer"
      PaperProps={{
        sx: {
          backgroundColor: "#FFFFFF",
          color: "#111827",
          borderRight: "1px solid #E2E8F0",
          width: 280,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};
